// extracted by mini-css-extract-plugin
module.exports = {"section-background":"styles_section-background__pTjaZ"};